import React from 'react';
import { Shield, Calendar, Lock, Cpu, HeadphonesIcon } from 'lucide-react';
import { whyBizsoft } from '../data/mock';

const iconMap = [Shield, Calendar, Lock, Cpu, HeadphonesIcon];

const WhyBizsoft = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0E3A5F] to-[#1F6FB2] text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {whyBizsoft.title}
          </h2>
          <p className="text-xl text-white/90">
            We're committed to delivering predictable, high-quality custom software solutions
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyBizsoft.points.map((point, index) => {
            const Icon = iconMap[index % iconMap.length];
            return (
              <div 
                key={index}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 hover:bg-white/15 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-14 h-14 bg-[#7AC943] rounded-full flex items-center justify-center mb-4">
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <p className="text-lg font-semibold leading-relaxed">
                    {point}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyBizsoft;
